import { Lightbulb, ShieldCheck, TrendingUp } from "lucide-react";
import { FadeIn } from "@/components/Reveal";

const PILLARS = [
  {
    icon: Lightbulb,
    word: "THINK",
    accent: "text-teal",
    bar: "bg-teal",
    copy: "Identify the risks, responsibilities, and operational gaps that may affect your business.",
  },
  {
    icon: ShieldCheck,
    word: "SAFE",
    accent: "text-navy",
    bar: "bg-navy",
    copy: "Establish systems, safeguards, and documented procedures that support business readiness.",
  },
  {
    icon: TrendingUp,
    word: "MITIGATION",
    accent: "text-amberdeep",
    bar: "bg-amber",
    copy: "Implement processes to reduce, monitor, and manage risk as the business grows.",
  },
];

export const Framework = () => (
  <section id="framework" className="border-y border-navy/5 bg-paper py-24 lg:py-32">
    <div className="container-tsm">
      <FadeIn className="max-w-3xl">
        <p className="eyebrow">Our Philosophy</p>
        <h2 className="mt-6 text-4xl font-extrabold leading-[1.08] tracking-tight text-navy sm:text-5xl lg:text-6xl" data-testid="framework-headline">
          Think Safe Mitigation: A Smarter Way to Protect Your Business.
        </h2>
      </FadeIn>

      <div className="mt-14 grid gap-6 md:grid-cols-3" data-testid="framework-pillars">
        {PILLARS.map((p, i) => (
          <FadeIn key={p.word} delay={i * 0.1} className="h-full">
            <article className="relative flex h-full flex-col overflow-hidden rounded-xl border border-navy/10 bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_rgb(23,43,58,0.10)]" data-testid={`framework-pillar-${i + 1}`}>
              <span className={`absolute inset-x-0 top-0 h-1.5 ${p.bar}`} aria-hidden="true" />
              <span className={`font-mono text-[11px] font-semibold uppercase tracking-[0.28em] ${p.accent}`}>
                {String(i + 1).padStart(2, "0")}
              </span>
              <p.icon className={`mt-5 h-8 w-8 ${p.accent}`} strokeWidth={1.8} />
              <h3 className={`mt-4 text-3xl font-extrabold tracking-tight text-navy ${p.accent}`}>{p.word}</h3>
              <p className="mt-4 flex-1 leading-relaxed text-ink/70">{p.copy}</p>
              {i < 2 && <span className="pointer-events-none absolute -right-3 top-1/2 hidden h-6 w-6 rotate-45 border-r border-t border-navy/15 bg-paper md:block" aria-hidden="true" />}
            </article>
          </FadeIn>
        ))}
      </div>

      <FadeIn delay={0.2}>
        <p className="mt-12 max-w-3xl border-l-4 border-amber pl-6 text-lg font-semibold leading-relaxed text-navy" data-testid="framework-statement">
          Risk cannot always be eliminated, but it can be identified, evaluated, and managed.
        </p>
      </FadeIn>
    </div>
  </section>
);
